import { useCallback, useState } from 'react';
import { useStore } from '../hooks';
import { PermissionCodes, PermissionLevels } from '../utils/enums';

export const useUserCheckPermissions = () => {
  const { authStore } = useStore();
  const [warningMessageTitle, setWarningMessageTitle] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const checkPermission = useCallback((permissionCode, permissionLevel, action, errorMessage) => {
    const resolvedCode = PermissionCodes[permissionCode] || permissionCode;
    const resolvedLevel = PermissionLevels[permissionLevel] || permissionLevel;

    const hasPermission = authStore.hasPermission(resolvedCode, resolvedLevel);

    if (action) {
      if (hasPermission) {
        action();
      } else if (errorMessage) {
        setWarningMessageTitle(errorMessage);
        setShowAlert(true);
      }
    }

    return hasPermission;
  }, [authStore, setWarningMessageTitle, setShowAlert]);

  const closeAlert = useCallback(() => {
    setShowAlert(false);
  }, []);

  return {
    checkPermission,
    warningMessageTitle,
    showAlert,
    closeAlert
  };
};
